import type { FC } from 'react';
import { ErrorIcon } from '@THC/components/Icons/Error';
import { MDText } from 'i18n-react';

import { SectionState } from 'Components/PageSectionLayout';

import LocalTexts from '../ServiceHistoryEnhancedSection.texts.json';

import styles from './ServiceHistoryError.module.scss';

const LocalT = new MDText(LocalTexts);

export const ServiceHistoryError: FC = () => {
	return (
		<SectionState
			className={styles.container}
			description={LocalT.translate('error.description')}
			icon={ErrorIcon}
			title={LocalT.translate('error.title')}
		/>
	);
};
